import 'intersection-observer';
import Observer from '@researchgate/react-intersection-observer';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

export const getPrintableThreshold = (ratio, range) =>
  range.reduce(
    (prev, curr) =>
      (Math.abs(curr - ratio) < Math.abs(prev - ratio) ? curr : prev)
  );

export const tresholds = [0, 0.25, 0.5, 0.75, 1];

export default (BaseComponent) => {
  const displayName =
    BaseComponent.displayName || BaseComponent.name || 'Component';
  class WithIntersectionDetection extends PureComponent {

    constructor(props) {
      super(props);
      this.handleChange = this.handleChange.bind(this);
    }

    handleChange({ isIntersecting, intersectionRatio }, unobserve) {
      this.props.onIntersection(
        this.props,
        isIntersecting,
        getPrintableThreshold(intersectionRatio.toFixed(2), tresholds),
        unobserve
      );
    }

    render() {
      return typeof this.props.onIntersection === 'function' ? (
        <Observer onChange={this.handleChange} threshold={tresholds}>
          <BaseComponent {...this.props} />
        </Observer>
      ) : (
        <BaseComponent {...this.props} />
      );
    }
  }
  WithIntersectionDetection.displayName = `WithIntersectionDetection(${displayName})`;
  WithIntersectionDetection.propTypes = {
    onIntersection: PropTypes.func
  };
  WithIntersectionDetection.defaultProps = {
    onIntersection: undefined
  };
  return WithIntersectionDetection;
};
